import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pressure-detail-template',
  templateUrl: './pressure-detail-template.component.html',
  styleUrls: ['./pressure-detail-template.component.less']
})
export class PressureDetailTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
